// extracted by mini-css-extract-plugin
export var ContentWithSidebar = "ContentWithSidebar-module--ContentWithSidebar--c2e9b";